<div class="episode-detail-container">
  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Caricamento episodio...</p>
  </div>

  <!-- Error State -->
  <div class="error-state" *ngIf="error && !isLoading">
    <div class="error-icon">⚠️</div>
    <p>{{ error }}</p>
    <button class="btn-back" (click)="goBack()">Torna alla lista</button>
  </div>

  <!-- Episode Content -->
  <article class="episode-detail" *ngIf="episode && !isLoading && !error">
    <!-- Back Button -->
    <button class="back-button" (click)="goBack()">
      ← Torna agli episodi
    </button>

    <!-- Hero Section -->
    <div class="episode-hero">
      <div class="episode-cover">
        <img 
          [src]="getCoverImageUrl(episode.coverImage, 'large')" 
          [alt]="episode.title"
        />
      </div>

      <div class="episode-info">
        <!-- Meta Info -->
        <div class="episode-meta">
          <span class="episode-number" *ngIf="episode.episodeNumber">
            Episodio {{ episode.episodeNumber }}
          </span>
          <span class="season" *ngIf="episode.seasonNumber">
            Stagione {{ episode.seasonNumber }}
          </span>
        </div>

        <!-- Title -->
        <h1 class="episode-title">{{ episode.title }}</h1>

        <!-- Short Description -->
        <p class="episode-short-description" *ngIf="episode.description">
          {{ episode.description }}
        </p>

        <!-- Additional Meta -->
        <div class="episode-details">
          <span class="date">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
            </svg>
            {{ formatDate(episode.publishedAt) }}
          </span>
          <span class="duration" *ngIf="episode.duration">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
            </svg>
            {{ formatDuration(episode.duration) }}
          </span>
        </div>

        <!-- Category and Tags -->
        <div class="taxonomy">
          <div class="categories" *ngIf="episode.category">
            <span class="label">Categoria:</span>
            <a 
              [routerLink]="['/categoria', episode.category.slug]"
              class="category-link"
            >
              {{ episode.category.name }}
            </a>
          </div>

          <div class="tags" *ngIf="episode.tags && episode.tags.length > 0">
            <span class="label">Tag:</span>
            <div class="tag-list">
              <ng-container *ngFor="let tag of episode.tags">
                <a 
                  *ngIf="tag.slug"
                  [routerLink]="['/tag', tag.slug]"
                  class="tag"
                >
                  #{{ tag.name }}
                </a>
                <span 
                  *ngIf="!tag.slug"
                  class="tag"
                >
                  #{{ tag.name }}
                </span>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Audio Player -->
    <div class="audio-player-section" *ngIf="spreakerPlayerUrl || episode.audioUrl">
      <h2>Ascolta l'episodio</h2>
      <iframe
        *ngIf="spreakerPlayerUrl; else integratedPlayer"
        class="spreaker-player"
        [src]="spreakerPlayerUrl"
        [title]="'Player Spreaker - ' + episode.title"
        width="100%"
        height="400"
        frameborder="0"
        loading="lazy"
        allow="autoplay; clipboard-write"
      ></iframe>
      <ng-template #integratedPlayer>
        <app-audio-player [audioUrl]="episode.audioUrl"></app-audio-player>
      </ng-template>
    </div>

    <!-- Long Description -->
    <div class="episode-description" *ngIf="episode.longDescription">
      <div [innerHTML]="episode.longDescription"></div>
    </div>

    <!-- Back to List -->
    <div class="actions">
      <button class="btn-primary" (click)="goBack()">
        ← Torna alla lista episodi
      </button>
    </div>
  </article>
</div>
